import { Layout, Row, Col } from 'antd';
import * as React from 'react';
import { Link } from 'react-router-dom';
import LoginWarning from './LoginWarning';
import Help from './Help';

const { Header } = Layout;

const refreshWindow = () => {
  window.location.reload();
};

export class SiteHeader extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  render() {
    return (
      <Header id="header">
          <Row gutter={24}>
            <Col sm={24} md={6} lg={4}>
              <Link to={'/'}>
                <img src={require('../static/LRS-Logo.png')} onClick={refreshWindow}/>
              </Link>
            </Col>
            <Col sm={24} md={9} lg={10} style={{paddingTop: 10}}>
              <span style={{fontWeight: 'bolder', fontSize: 'x-large', fontFamily: 'PoppinsBold,sans-serif'}}>Historical Land Records Viewer</span>
            </Col>
            <Col sm={24} md={8} lg={9} style={{paddingTop: 10}}>
              <LoginWarning messageType={this.props.showMessage}/>
            </Col>
            <Col sm={24} md={1} lg={1} style={{paddingTop: 10}}>
              <Help/>
            </Col>
          </Row>
      </Header>
      )
  }
}



// WEBPACK FOOTER //
// ./src/components/SiteHeader.tsx